import { StrictMode, type ReactNode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { hit as hitMetrika } from '../analytics'

export interface UtilityAppBootstrapOptions {
  app: ReactNode
  rootId?: string
  strictMode?: boolean
}

export interface UtilityRouteResolvedEvent {
  fromLocation?: unknown
  hrefChanged?: boolean
}

export interface UtilityRouteChangeTracker {
  subscribe(
    eventType: 'onResolved',
    listener: (event: UtilityRouteResolvedEvent) => void,
  ): unknown
}

export function renderUtilityApp({
  app,
  rootId = 'root',
  strictMode = true,
}: UtilityAppBootstrapOptions): void {
  const rootElement = document.getElementById(rootId)
  if (!rootElement) {
    throw new Error(`Root element #${rootId} not found in the document.`)
  }

  const tree = strictMode ? <StrictMode>{app}</StrictMode> : app

  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, tree)
  } else {
    createRoot(rootElement).render(tree)
  }
}

export function trackUtilityRouteChanges(
  router: UtilityRouteChangeTracker,
  currentHref: () => string = browserHref,
): void {
  router.subscribe('onResolved', (event) => {
    if (!event.fromLocation || !event.hrefChanged) {
      return
    }

    hitMetrika(currentHref())
  })
}

function browserHref(): string {
  if (typeof window === 'undefined') return ''
  return window.location.href
}
